<template>
   <!-- Page Content -->
    <div id='page-wrapper'>
      <vue-element-loading size="64" is-full-screen :active="isLoadingData" text="جارى تحميل البيانات" spinner="bar-fade-scale" color="#A4A4A4"/>
        <div class='container-fluid'>
            <div class='row'>
                <div class='col-lg-12'>
                    <h1 class='page-header'>بيانات الشركة</h1>
                </div>
                <!-- /.col-lg-12 -->
            </div>
            <!-- /.row -->
            <div class='row'>
                <div class='col-lg-12'>
                    <div class='panel panel-default'>
                        <div class='panel-heading'>
                          هنا يتم التعديل فى البيانات الرئيسية للشركة
                        </div>
                        <!-- /.panel-heading -->
                        <div class='panel-body'>
                            <div class="alert alert-danger alert-dismissable" v-if="errorShow">
                              <ul v-if="validationErrors">
                                  <li v-for="err in validationErrors"  v-bind:key="err.key" v-bind:value="err.key">{{ err }}</li>
                              </ul>
                            </div>
                            <div class="alert alert-success alert-dismissable" v-if="successShow">
                               {{success}}
                            </div>
                              <div class="form-group col-lg-6 col-sm-6">
                                <label>اسم الشركة:</label>
                                  <input style="text-align:center" v-model="record.name" class="form-control" name="name" type="text">
                              </div>
                              <div class="form-group col-lg-6 col-sm-6">
                                <label>اسم المسئول:</label>
                                <input style="text-align:center" v-model="record.manager" class="form-control" name="manager" type="text">
                              </div>
                              <div class="form-group col-lg-12 col-sm-12">
                                <label>العنوان: </label>
                                <input style="text-align:center" v-model="record.address" class="form-control" name="address" type="text">
                              </div>
                              <div class="form-group col-lg-3 col-sm-6">
                                <label>رقم التليفون</label>
                                <input style="text-align:center" v-model="record.phone" class="form-control" name="phone" type="text">
                              </div>
                              <div class="form-group col-lg-3 col-sm-6">
                                <label>السجل التجارى:</label>
                                <input style="text-align:center" v-model="record.tax_record" class="form-control" name="tax_record" type="text">
                              </div>
                              <div class="form-group col-lg-3 col-sm-6">
                                <label>البطاقة الضريبية:</label>
                                <input style="text-align:center" v-model="record.tax_card" class="form-control" name="tax_card" type="text">
                              </div>
                              <div class="form-group col-lg-3 col-sm-6">
                                <label>عنوان الفاتورة:</label>
                                <input style="text-align:center" v-model="record.Invoice_header" class="form-control" name="Invoice_header" type="text">
                              </div>
                              <div class="row" style="text-align:center">
                                <button v-show="$per.value.saveCompanyInfo" @click="saveData" type="button" class="btn btn-primary">حفظ</button>
                              </div>
                        </div>
                        <!-- /.panel-body -->
                    </div>
                    <!-- /.panel -->
                </div>
                <!-- /.col-lg-12 -->
            </div>
         </div>
         <!-- /.container-fluid -->
    </div>
</template>
<script>
import axios from 'axios'
export default {
  name: 'Company_Info',
  data () {
    return {
      libLoaded: false,
      bShowScanner: false,
      validationErrors: '',
      record: {},
      errorShow: false,
      successShow: false,
      isLoadingData: false,
      isLoadingSave: false,
      errors: ''
    }
  },
  created () {
    this.GetData()
  },
  methods: {
    GetData () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'getCompanyInfo', {
        token: localStorage.getItem('token')
      })
        .then(({ data }) => {
          this.record = data[0]
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.isLoadingData = false
        })
    },
    saveData () {
      this.isLoadingSave = true
      axios.post(this.$apiURL + 'saveCompanyInfo', {
        token: localStorage.getItem('token'),
        name: this.record.name,
        manager: this.record.manager,
        phone: this.record.phone,
        address: this.record.address,
        tax_record: this.record.tax_record,
        tax_card: this.record.tax_card,
        Invoice_header: this.record.Invoice_header
      })
        .then(res => {
          this.isLoadingSave = false
          if (this.record.id === 0) {
            this.success = 'تم الحفظ بنجاح'
            this.successShow = true
            this.errorShow = false
          } else {
            this.success = 'تم الحفظ بنجاح'
            this.successShow = true
            this.errorShow = false
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.errorShow = true
          this.isLoadingSave = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/company/ComInfo.vue